import IpubDatePicker from './src/main'

/* istanbul ignore next */
IpubDatePicker.install = function(Vue) {
  Vue.component(IpubDatePicker.name, IpubDatePicker)
}

export default IpubDatePicker
